var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsonp, request } from '@tencent/ovb-request';
var targetWindow = window;
export default {
    setJSONPTarget: function (win) {
        targetWindow = win;
    },
    jsonp: function (url, userOpts) {
        var opts = __assign({ targetWindow: targetWindow }, userOpts);
        return jsonp(url, opts);
    },
    img: function (url) {
        return new window.Promise((function (resolve, reject) {
            var img = new Image();
            img.src = url;
            resolve();
        }));
    },
    fetch: function (url, opts) {
        if (opts === void 0) { opts = {}; }
        return request({
            url: url,
            method: opts.method,
            body: opts.body,
        }).then(function (res) { return res.json(); });
    },
    /**
     * 发起xhr请求
     */
    xhr: function (opts) {
        var totalRetryCount = opts.retryCount || 0;
        var startTimestamp = +new Date();
        var currentRetryCount = 0;
        var impl = function (resolve, reject) {
            var retryHandler = function (error) {
                if (error === void 0) { error = 'xhrNetworkError'; }
                if (currentRetryCount < totalRetryCount) { // retry again
                    currentRetryCount++;
                    impl(resolve, reject);
                }
                else {
                    reject({ error: error, target: xhr });
                }
            };
            var xhr = new XMLHttpRequest();
            // 要先 open，否则 IE 下会抛出异常
            // @see https://stackoverflow.com/questions/28524485/xmlhttprequest-throwing-invalidsateerror-saying-object-state-must-be-opened
            xhr.open(opts.method || 'get', opts.url);
            if (opts.timeout) {
                xhr.timeout = opts.timeout;
            }
            if (opts.responseType) {
                xhr.responseType = opts.responseType;
            }
            xhr.withCredentials = !!opts.withCredentials;
            xhr.ontimeout = opts.ontimeout;
            if (opts.range) {
                xhr.setRequestHeader('Range', "bytes=".concat(opts.range[0], "-").concat(opts.range[1]));
            }
            if (opts.headers) {
                Object.keys(opts.headers).forEach(function (key) {
                    xhr.setRequestHeader(key, opts.headers[key]);
                });
            }
            xhr.onload = function () {
                if (xhr.status === 200 || xhr.status === 206) {
                    resolve({ data: xhr.response, target: xhr, startTimestamp: startTimestamp });
                    return;
                }
                retryHandler('xhrStatusCodeError');
            };
            xhr.onerror = function (e) {
                retryHandler();
            };
            xhr.onabort = function () {
                // to do
            };
            xhr.ontimeout = function () {
                retryHandler('xhrTimeoutError');
            };
            if (opts.body) { // post
                xhr.send(opts.body);
            }
            else {
                xhr.send();
            }
        };
        return new Promise((function (resolve, reject) {
            impl(resolve, reject);
        }));
    },
};
